<div class="col-lg-12" [ngClass]="customClass">
  <div class="photo-area">
    <p *ngIf="subtitle" class="subtitle">{{ subtitle }}</p>
    <p>{{ action }}</p>
    <div class="boxs-upload" [ngClass]="{ 'custom-box': customBox }">
      <label class="box box-document-end" [ngClass]="{ 'border-0': preview }">
        <div class="wrap-input100">
          <div
            class="empty-imagem"
            style="margin-right: 3px"
            [hidden]="preview"
          >
            <i
              ><img
                src="assets/img/products/cadastrodeprodutosupload.png"
                alt=""
            /></i>
            <p>Arraste e solte ou</p>
            <div class="select-img" [ngClass]="customClass">
              <span>{{ text }}</span>
            </div>
          </div>
          <img
            class="img-preview"
            [src]="getSantizeUrl(preview)"
            alt="imagem-preview"
            [hidden]="!preview"
          />
          <div class="edit-img" [hidden]="!preview">
            <div class="box-icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.794 4.55205L15.424 0.182054C15.366 0.124031 15.2972 0.0780004 15.2215 0.0465945C15.1457 0.0151886 15.0645 -0.000976563 14.9825 -0.000976562C14.9005 -0.000976562 14.8193 0.0151886 14.7435 0.0465945C14.6678 0.0780004 14.599 0.124031 14.541 0.182054L0.184 14.5401C0.125861 14.5979 0.0796861 14.6666 0.0481142 14.7422C0.0165424 14.8179 0.00019283 14.8991 0 14.9811L0 19.3521C0 19.5175 0.0657427 19.6763 0.182765 19.7933C0.299788 19.9103 0.458505 19.9761 0.624 19.9761H5C5.16545 19.9759 5.32407 19.9101 5.441 19.7931L19.794 5.43505C19.852 5.3771 19.8981 5.30828 19.9295 5.23252C19.9609 5.15677 19.977 5.07556 19.977 4.99355C19.977 4.91155 19.9609 4.83034 19.9295 4.75459C19.8981 4.67883 19.852 4.61001 19.794 4.55205ZM4.736 18.7281H1.247V15.2411L11.547 4.94105L15.034 8.42805L4.736 18.7281ZM15.919 7.54405L12.432 4.05705L14.983 1.50605L18.47 4.99405L15.919 7.54405Z"
                  fill="white"
                />
              </svg>
            </div>
            <p>EDITAR FOTO</p>
          </div>
          <input
            type="file"
            #input
            class="form-control"
            id="document-end"
            aria-describedby="nome"
            placeholder="Imagem"
            (change)="showPreview($event)"
            accept="{{ extensions }}"
            hidden
          />
        </div>
      </label>
    </div>
  </div>
</div>
